import { MANAGEFEEDS_GET_DATA, DISPATCH_FEED_STATUS, DISPATCH_DELETE_FEED, DISPATCH_UPDATE_ACCOUNT } from "../reducers/keys"
import { FACEBOOK_AUTOCOMPLETE, GET_MANAGEFEEDS, HANDLE_AUTOCOMPLETE, FEED_STATUS_UPDATE, DELETE_FEED, UPDATE_SOCIAL_ACCOUNT, UPLOAD_FEED_PROFILE_IMAGE } from "./api";
import HttpClient from "./http-client";
import { TOAST_LOADING, TOAST_SUCCESS, TOAST_DISMISS, ucFirst, getInitialRoute, SOCKET_CONNECTION } from "../utils";
import { SHOW_DEMO_POST } from "./wallsAction";
import { getWidgetWallData } from "./wallDataAction";
import { toast } from "react-toastify";

export const GET_FEEDS = (stopLoader) => {

    return (dispatch) => {
        const data = {
            "wallId": localStorage.getItem('wallId'),
            "isCollaborator": 0,
            "productId": 4
        }

        new HttpClient().post(GET_MANAGEFEEDS, data).then(res => {
            const { data } = res;
            if (data.status) {

                if (stopLoader) {
                    stopLoader(data.responsedata);
                }
                dispatch({ type: MANAGEFEEDS_GET_DATA, payload: { feeds: data.responsedata, totalFeeds: data.feedCount } })
            }
        }).catch((ex) => {
            if (stopLoader) {
                stopLoader();
            }
        })
    }
}

export const ACTION_UPDATE_SOCIAL_ACCOUNT = (accountId, feedId, callback) => {

    TOAST_LOADING();
    return (dispatch) => {
        new HttpClient().get(`${UPDATE_SOCIAL_ACCOUNT}/${accountId}/${feedId}`).then(res => {
            const { data } = res
            if (data.status) {
                TOAST_DISMISS()
                dispatch({ type: DISPATCH_UPDATE_ACCOUNT, payload: { "feedId": feedId, "accountId": accountId, } })
                TOAST_SUCCESS(`Account updated successfully`)
                callback();
            }
        }).catch((error) => {

        })
    }
}


 

export const ACTION_DELETE_FEED = (feedId, callback) => {
    const dataForm = {
        "feedId": [`${feedId}`],
        "isCollaborator": 0,
        "wallId" : localStorage.getItem('wallId'),
        adminId: localStorage.getItem('Isadmin') || '',
    }

 
    TOAST_LOADING();
    return (dispatch) => {
        new HttpClient().post(DELETE_FEED, dataForm).then(res => {
            const { data } = res

            if (data.status) {
                const product =  getInitialRoute();

                if(product != 'widget' && data.responseData && data.responseData.length > 0){
                     SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': localStorage.getItem('wallId'), sync: data.responseData[0].id });
                }
                
                TOAST_DISMISS()
                dispatch({ type: DISPATCH_DELETE_FEED, payload: feedId })
                TOAST_SUCCESS(`Feed Deleted successfully`)
                callback();
            }
        }).catch((error) => {

        })
    }
}

export const ACTION_FEED_STATUS = (feedId, status, action, postCount, callback) => {
    const dataForm = {
        "feedId": feedId,
        "action": action,
        "status": status,
        "isCollaborator": 0,
        adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId')
    }
    TOAST_LOADING();
    return (dispatch) => {
        new HttpClient().post(FEED_STATUS_UPDATE, dataForm).then(res => {
            const { data } = res;
            if (data.status) {
                if(data.responseData && data.responseData.length > 0){
                    SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': localStorage.getItem('wallId'), sync: data.responseData[0].id });
                }
                TOAST_DISMISS()
                if(status && postCount > 0) SHOW_DEMO_POST(0, localStorage.getItem('wallId'));
                dispatch({ type: DISPATCH_FEED_STATUS, payload: { "feedId": feedId, "status": status, "action": action } })
                dispatch(getWidgetWallData(localStorage.getItem('ownerId'), localStorage.getItem('wallId')))

                TOAST_SUCCESS(`${ucFirst(action)} ${status == 1 ? 'on' : 'off'} updated successfully`)
                callback()
            }
        }).catch((error) => {

        })
    }
}


export const AUTOCOMPLETE = (data) => {
    const url = data.networkId == 1 ? HANDLE_AUTOCOMPLETE : FACEBOOK_AUTOCOMPLETE
    return new HttpClient().post(url, data)
}

export const uploadFeedProfileImage = (path, feedId, callback=()=>{}) => {
    const toastID = toast.loading("Loading...", { autoClose: 3000 })
    new HttpClient().post(UPLOAD_FEED_PROFILE_IMAGE, { feedId, profilePicture: path }).then(response => {
        const { responseMessage, responseCode } = response.data
        if (responseCode == 200) {
            toast.update(toastID, { render: responseMessage, type: toast.TYPE.SUCCESS, autoClose: 3000 });
            callback();
        }
    }).catch(ex =>{
        if (ex.response && ex.response.data) {
            const { data } = ex.response;
            const { responseMessage } = data;
            toast.update(toastID, { render: responseMessage, type: toast.TYPE.ERROR, autoClose: 3000 });
        }
    }).finally(() => {
        setTimeout(() => toast.dismiss(toastID), 3000);
    });
}